module.exports = __webpack_public_path__ + "img/JWP-logo.fee34f4c.svg";